// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__rpHiv","counter_button":"counter_counter_button__UfwG+","counter_input":"counter_counter_input__BiI0G"};